import React from "react";
import { Headline, Body, AccentText } from "./brand";
import SectionBadge from "./SectionBadge";

/**
 * Section header — one headline per section, left-aligned (brand rule).
 */
const SectionHeader = ({
  title,
  description,
  para,
  accent,
  light,
  bold,
  tone = "blue",
  width,
  className = "",
}) => {
  return (
    <div className={`flex justify-start w-full items-start ${className}`}>
      <div
        className={`flex flex-col items-start gap-3 md:gap-4 text-left ${
          width || "w-full max-w-3xl"
        }`}
      >
        {title && <SectionBadge className="mb-0">{title}</SectionBadge>}
        {(light || bold || description) && (
          <Headline
            light={light}
            bold={bold || (!light ? description : undefined)}
            tone={tone}
            as="h2"
          >
            {!light && !bold && description ? (
              <span className="font-extrabold">{description}</span>
            ) : null}
          </Headline>
        )}
        {accent && <AccentText>{accent}</AccentText>}
        {para && <Body className="md:text-[16px]">{para}</Body>}
      </div>
    </div>
  );
};

export default SectionHeader;
